export default "__VITE_ASSET__bfbd4673__"